import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse, ResponseStatus, PayloadResponse, MainResponse } from '../models/response.model';
import { HistoryRequest, HistoryResponse, AddTags, AssignCoupon } from '../models/telemed.model';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { FormVerifyCustomerService } from './form-verify-customer.service';
import { Channel } from '../models/channel.model';
import { Identity } from '../models/customer.model';
@Injectable({
  providedIn: 'root'
})
export class TelemedService {

  constructor(
    private http: HttpClient,
    private verifyCustomerService: FormVerifyCustomerService,
  ) { }

  apiGetInformationEncrypt(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/line/telemed/informationEncrypt', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }

  apiCheckAndPushMessage(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/line/telemed/CheckAndPushMessage', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }
  // mock = {"available":[{"date":1629392400000,"id":"1950DCA9-C435-4AE1-9B5F-B5D5A38735FE"}],"usage":[],"complete":[{"usage_detail_id":"2F5A3FF9-66FC-4A51-8118-E11449E04237","usage_id":"117749E2-9A42-447A-B979-503685FBD6DC","date":1628568300000,"url":"https://devsl.doctoratoz.co/#/SL1628568315608"},{"usage_detail_id":"0A7249B3-A0ED-4449-950D-563EE1D93D0C","usage_id":"E5D2F71E-69B0-4997-908D-65E15C489C82","date":1628566200000,"url":"https://devsl.doctoratoz.co/#/SL1628508111218"},{"usage_detail_id":"10EC9559-7C6B-42FF-B346-AA7A1F93420C","usage_id":"C8C0EBA7-CAF5-4875-AD80-2996180EEFCA","date":1628567700000,"url":"https://devsl.doctoratoz.co/#/SL1628567723649"},{"usage_detail_id":"2D9C139F-AA59-41E6-BC17-9F7BE052ED87","usage_id":"806FD1E2-EE08-4BED-B7A1-D494289F4946","date":1628497800000,"url":"https://devsl.doctoratoz.co/#/SL1628496014203"},{"usage_detail_id":"4F3163F3-A5D0-4F16-ABB5-EA4BBAEF6E23","usage_id":"F7B47427-0968-4A1D-B749-BF28F5294B99","date":1628146620000,"url":"https://devsl.doctoratoz.co/#/SL1628146622732"},{"usage_detail_id":"887BA29C-6B64-4568-8172-31F24C708961","usage_id":"1A681A5B-B761-468A-9B55-EAF569AE9F89","date":1628153460000,"url":"https://devsl.doctoratoz.co/#/SL1628153519916"}]}
  apiHistory(body: HistoryRequest): Observable<any> {
    // return new Observable(res => res.next(this.mock))
    return this.http.post<ApiResponse<HistoryResponse>>(environment.endpointBackend + '/api/line/telemed/history', body).pipe(
      map(
        result => {
          switch (result.response_code) {
            case ('40000'):
              return result.payload
            default:
              return null
          }
        }
      )
    )
  }
  apiAddTagRef(body: AddTags): Observable<any> {
    return this.http.post<ApiResponse<AddTags>>(environment.endpointBackend + '/api/line/digitalRm/addTags', body).pipe(
      map(
        result => {
          switch (result.response_code) {
            case ('40000'):
              return result.payload
            default:
              return null
          }
        }
      )
    )
  }

  telemedAssignCoupon(channel:Channel): Promise<string> {
    return new Promise(async (resolve, reject) => {
      if (!channel.appCode || !channel.port || !channel.prod) {
        return resolve("S201"); // ไม่ต้อง assign coupon เพราะเงื่อนไขไม่ครบ
      }
      let payloadAssignCoupon: AssignCoupon = {
        "product": channel.prod,
        "port_type": channel.port,
        "app_code": channel.appCode,
        "register_type": channel.registerType,
        // "channel_identity":channel.channel_identity,
        "electronic_channel":channel.electronic_channel,
        "application_channel_reference":channel.application_channel_reference

      }
      this.http.post<MainResponse>(environment.endpointBackend + '/api/line/telemed/assignCoupon', payloadAssignCoupon).pipe(
        map(
          result => {
            switch (result.response_code) {
              case ('40000'):
                return resolve("S200")
              case ('40001'):
              case ('40002'):
                return resolve("E402")
              case ('40003'): // duplicate
                return resolve("E403")
              default:
                return resolve("E500")
            }
          }
        )
      ).subscribe();


    })
  }


}
